import React from 'react';
import SeasonalDiscoveryPage from './SeasonalDiscoveryPage';

// Replaces the thin HubPage wrapper — one comprehensive publication-style page.
const SeasonalDiscoveryHubPage = () => <SeasonalDiscoveryPage />;

export default SeasonalDiscoveryHubPage;
